// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { SnackbarContent, CustomContentProps, SnackbarKey } from 'notistack';
import React from 'react';
import { Close } from '@mui/icons-material';
import { Box, Button, Card, CardContent, IconButton, Typography } from '@mui/material';

// relevant notistack docs: https://notistack.com/features/customization#custom-component

interface UtilitiesSnackbarProps extends CustomContentProps {
  onUtilitiesClose: (snackbarKey: SnackbarKey) => void;
  onUtilitiesDetails: (snackbarKey: SnackbarKey) => void;
}

const UtilitiesSnackbar = React.forwardRef<HTMLDivElement, UtilitiesSnackbarProps>(
  function UtilitiesSnackbar(props, ref) {
    const {
      // You have access to notistack props and options 👇🏼
      id,
      message,
      // as well as your own custom props 👇🏼
      onUtilitiesClose,
      onUtilitiesDetails,
    } = props;

    return (
      <SnackbarContent ref={ref} role="alert">
        <Card
          variant="outlined"
          sx={{ borderLeftColor: 'error.main', borderLeftWidth: '4pt', width: '365px' }}
        >
          <CardContent sx={{ ':last-child': { paddingBottom: 1 } }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Typography variant="body1" color="error.main">
                Error
              </Typography>
              <IconButton size="small" onClick={() => onUtilitiesClose(id)}>
                <Close sx={{ color: 'text.primary' }} fontSize="small" />
              </IconButton>
            </Box>
            <Box sx={{ display: 'inline-flex', width: '100%', alignItems: 'center' }}>
              <Typography variant="body2">{message}</Typography>
              <Button variant="text" sx={{ ml: 'auto' }} onClick={() => onUtilitiesDetails(id)}>
                Details
              </Button>
            </Box>
          </CardContent>
        </Card>
      </SnackbarContent>
    );
  },
);

export default UtilitiesSnackbar;
